import React from 'react';

import Footer from './../components/layout/Footer';
import Header from './../components/layout/Header';

import DropcartOffcanvas from '~/components/layout/header/DropcartOffcanvas';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <DropcartOffcanvas />
    </>
  );
};

export default Layout;
